'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';

export default function NotFound() {
    const t = useTranslations('Common');

    return (
        <div className='flex min-h-screen items-center justify-center bg-gray-100'>
            <div className='max-w-md rounded-lg bg-white p-8 text-center'>
                <h1 className='text-6xl font-bold text-gray-300'>404</h1>
                <Link
                    href='/discover'
                    className='inline-block rounded bg-blue-600 px-4 py-2 font-medium text-white transition-colors'
                >
                    {t('not_found_back_home')}
                </Link>
            </div>
        </div>
    );
}
